import { TaskStatus } from '@/types/task'

/**
 * Task State Machine Service
 * Handles task status transitions and validation
 */
class TaskStateMachineService {
  /**
   * Get possible status transitions from the current status
   */
  getPossibleStatuses(currentStatus: TaskStatus): TaskStatus[] {
    switch (currentStatus) {
      case TaskStatus.PENDING:
        return [TaskStatus.IN_PROGRESS, TaskStatus.CANCELLED]
      
      case TaskStatus.IN_PROGRESS:
        return [TaskStatus.ON_HOLD, TaskStatus.COMPLETED, TaskStatus.CANCELLED]
      
      case TaskStatus.ON_HOLD:
        return [TaskStatus.IN_PROGRESS, TaskStatus.CANCELLED]
      
      case TaskStatus.COMPLETED:
      case TaskStatus.CANCELLED:
        // Terminal states - no transitions allowed
        return []
      
      default:
        return []
    }
  }

  /**
   * Check if a status transition is valid
   */
  isValidTransition(fromStatus: TaskStatus, toStatus: TaskStatus): boolean {
    const possibleStatuses = this.getPossibleStatuses(fromStatus)
    return possibleStatuses.includes(toStatus)
  }

  /**
   * Get the event required for a status transition
   */
  getEventForTransition(fromStatus: TaskStatus, toStatus: TaskStatus): string | null {
    // Map status transitions to events
    if (fromStatus === TaskStatus.PENDING && toStatus === TaskStatus.IN_PROGRESS) {
      return 'START_TASK'
    }
    if (fromStatus === TaskStatus.IN_PROGRESS && toStatus === TaskStatus.ON_HOLD) {
      return 'PAUSE_TASK'
    }
    if (fromStatus === TaskStatus.ON_HOLD && toStatus === TaskStatus.IN_PROGRESS) {
      return 'RESUME_TASK'
    }
    if (fromStatus === TaskStatus.IN_PROGRESS && toStatus === TaskStatus.COMPLETED) {
      return 'COMPLETE_TASK'
    }
    if (toStatus === TaskStatus.CANCELLED) {
      return 'CANCEL_TASK'
    }
    
    return null
  }
}

export default new TaskStateMachineService()
